export default __webpack_public_path__ + "static/media/m_use_action_hk.775c8c45.png";